import axios from 'axios';
import apiClient from '../ApiClient';
import { redirectToLoginPage } from '../../../helper';

const MapService = {
  getMAP: async (params, instance) => {
    try {
      return (await apiClient.post('/fecthmapData',params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
          redirectToLoginPage(instance);
      }
      return null;
    }
  },
};

export default MapService;
